export interface MobileDownloadLinks {
  iosAppStoreUrl: string | null
  androidPlayStoreUrl: string | null
  androidApkUrl: string | null
}

export function getMobileDownloadLinks(): MobileDownloadLinks {
  const iosAppStoreUrl = import.meta.env.VITE_IOS_APP_STORE_URL?.trim() || null
  const androidPlayStoreUrl = import.meta.env.VITE_ANDROID_PLAY_STORE_URL?.trim() || null
  const androidApkUrl = import.meta.env.VITE_ANDROID_APK_URL?.trim() || null

  return { iosAppStoreUrl, androidPlayStoreUrl, androidApkUrl }
}

export function hasPublishedStoreLinks(links: MobileDownloadLinks): boolean {
  return Boolean(links.iosAppStoreUrl || links.androidPlayStoreUrl || links.androidApkUrl)
}
